import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { Firestore } from '@angular/fire/firestore';
import { MatSnackBar } from '@angular/material/snack-bar';

import { User } from '@app/models/user';
import { ReportService } from '@app/services/report.service';
import { Utility } from '@app/models/utility';
import { Define } from 'src/app/models/define';
import htmlToPdfmake from 'html-to-pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { PdfMakeService } from '@app/services/pdf-make.service';
import { collection, DocumentData, DocumentReference, getDocs } from 'firebase/firestore';

export interface TeamInfo { id: string; name: string; selected: boolean; }

@Component({
  selector: 'app-payroll-report',
  templateUrl: './payroll-report.component.html',
  styleUrls: ['./payroll-report.component.css']
})
export class PayrollReportComponent implements OnInit {

  teams: TeamInfo[];
  selectedTeams: TeamInfo[];

  startDate: Date;
  endDate: Date;

  IsRecentlyMonth: Boolean;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  _selectMonth: Date;
  get selectMonth(): Date {
    return this._selectMonth;
  }
  set selectMonth(value: Date) {
    this._selectMonth = value;
    // 直近3ヵ月ならばtrue
    this.IsRecentlyMonth = this.monthes.findIndex(m => m.id === this._selectMonth) >= 21;
  }
  monthes: { id: Date, value: string }[];
  closingDays: {id: number , value: string}[];

  _selectClosingDayIndex: number;
  get selectClosingDayIndex(): number{
    return this._selectClosingDayIndex;
  }
  set selectClosingDayIndex(value: number){
    this._selectClosingDayIndex = value;
  }

  isProcessing: boolean;


  constructor(
    private firestore: Firestore,
    private report: ReportService,
    public auth: AuthService,
    private _snackBar: MatSnackBar,
    private pdfMakeService: PdfMakeService
  ) {
    this.teams = new Array();

    // 表示月選択項目の設定
    const today = new Date();
    let startMonthNum = 0;
    if (today.getDate() <= 15) {
      startMonthNum = today.getMonth();
    } else {
      startMonthNum = today.getMonth() + 1;
    }

    const beforeRange = 23;
    const startMonth = new Date();
    startMonth.setMonth(startMonthNum - beforeRange);
    startMonth.setDate(1); // 月初
    this.monthes = new Array();
    for (let i = 0; i <= beforeRange; i++) {
      const month = new Date(startMonth);
      month.setMonth(month.getMonth() + i);
      this.monthes.push({ id: month, value: `${month.getFullYear()}年${month.getMonth() + 1}月度` });
    }
    this.selectMonth = this.monthes[23].id;

    // 締め日選択項目の設定
    this.closingDays = new Array();
    for (let i = 0; i < Define.closingDaysList.length; i++){
      this.closingDays.push({id: Define.closingDaysList[i].id, value: Define.closingDaysList[i].value});
    }
    this.selectClosingDayIndex = this.closingDays[0].id;

  }

  async ngOnInit() {
    await this.getTeamList();
  }

  async getTeamList() {
    const snapshot = await getDocs(collection(this.firestore, 'team'));
    this.teams = snapshot.docs.map(docSnap => {
      const data = docSnap.data() as DocumentData;
      return { id: docSnap.id, name: data['name'] as string, selected: false };
    });
    this.teams.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else if (a.name === b.name) {
        return 0;
      }
      return 0;
    });
  }

  async createReport(format: string) {
    console.log('create report');
    // TODO ここでStartDate,EndDateを生成するようにしたい
    switch (this.selectClosingDayIndex) {
        case Define.closingDay.DayOf10:
          this.startDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth() - 1, 11);
          this.endDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth(), 10);
          break;
        case Define.closingDay.DayOf15:
          this.startDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth() - 1, 16);
          this.endDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth(), 15);
          break;
        case Define.closingDay.DayOf20:
          this.startDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth() - 1, 21);
          this.endDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth(), 20);
          break;
        case Define.closingDay.DayOf25:
          this.startDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth() - 1, 26);
          this.endDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth(), 25);
          break;
        case Define.closingDay.EndOfMonth:
          this.startDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth(), 1);
          this.endDate = new Date(this._selectMonth.getFullYear(), this._selectMonth.getMonth() + 1, 0); // 翌月の1日前
          console.log(this.endDate);
          break;
      }
      console.log(this.startDate + ' - ' + this.endDate);

    console.log(this.selectedTeams);
    if (this.selectedTeams === undefined || this.selectedTeams.length <= 0) {
      return;
    }

    this.isProcessing = true;
    const zipData: { data: any, name: string, folder: string }[] = [];

    let fontName: string | undefined;
    if (format === 'PDF') {
      fontName = await this.pdfMakeService.ensureFonts();
    }

    try {
      const userSnapshot = await getDocs(collection(this.firestore, 'users'));
      const tasks = userSnapshot.docs.map(async userDoc => {
        const teamRef = userDoc.data()['team'] as DocumentReference<DocumentData>;
        const matchTeam = this.selectedTeams.find((team) => team.id === teamRef.id);
        const targetUser = Object.assign({}, userDoc.data()) as User;
        if (!targetUser || !matchTeam) {
          return;
        }

        console.log(`match user ${targetUser.displayName}`);
        const result = await this.report.loadHistories(targetUser, this.startDate, this.endDate, !(this.IsRecentlyMonth));
        const teamName = matchTeam.name;
        const startDateText = Utility.convertDateToDateText(this.startDate, true);
        const endDateText = Utility.convertDateToDateText(this.endDate, true);

        if (format === 'CSV') {
          const csv = await result.createCsv();
          zipData.push({
            data: csv,
            name: `勤怠記録_${targetUser.id}_${targetUser.displayName}_${teamName}_${startDateText}-${endDateText}.csv`,
            folder: matchTeam.name
          });
        } else if (format === 'PDF' && fontName) {
          const [html, lineNumber] = await result.createHTMLforPDF();
          const docDef: TDocumentDefinitions = {
            info: {
              title: `${teamName}_${targetUser.id}_${targetUser.displayName}`,
              author: '夏原工業 勤怠管理システム',
              subject: '打刻レポート',
              keywords: '',
            },
            content: [htmlToPdfmake(html, { tableAutoSize: true })],
            defaultStyle: {
              font: fontName,
              fontSize: Math.min(480 / lineNumber, 10)
            },
            pageSize: 'A4'
          };
          const pdfDocGenerator = this.pdfMakeService.createPdf(docDef);
          const blob = await new Promise<Blob>((resolve) => {
            pdfDocGenerator.getBlob(resolve);
          });
          zipData.push({
            data: blob,
            name: `勤怠記録_${targetUser.id}_${targetUser.displayName}_${teamName}_${startDateText}-${endDateText}.pdf`,
            folder: matchTeam.name
          });
        }
      });

      await Promise.all(tasks);
      this.showSnackbar('出力しました！');
      console.log(`report generate end`);
      if (format === 'CSV') {
        Utility.downloadCSVZip(`勤怠記録.zip`, zipData);
      } else if (format === 'PDF') {
        Utility.downloadPDFZip(`勤怠記録.zip`, zipData);
      }
    } finally {
      this.isProcessing = false;
    }
  }

  showSnackbar(text: string): void {
    this._snackBar.open(text, undefined, { duration: 2 * 1000 });
  }
}
